import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const TABS = [
  { key: "general", label: "General Trade", tradeLabel: "GENERAL TRADE" },
  { key: "modern",  label: "Modern Trade",  tradeLabel: "MODERN TRADE"  },
];

export const HEADER_LABELS = [
  "Date",
  "Number of Stores Uploaded",
  "Upload %",
  "Cumulative Upload",
  "Cumulative Upload %",
  "Count of Image Upload- Cumulative",
  "Yet to upload",
  "Yet to upload %",
];

export const FIELD_NAMES = [
  "date",
  "numberOfStoresUploaded",
  "uploadPercentage",
  "cumulativeUpload",
  "cumulativeUploadPercentage",
  "countOfImageUploadCumulative",
  "yetToUpload",
  "yetToUploadPercentage",
];

export const PAGE_SIZE = 10;

const COL_WIDTHS_EXCEL = [14, 24, 12, 18, 20, 32, 14, 16];

export const COLUMN_DEFS = HEADER_LABELS.map((headerName, i) => ({
  headerName,
  field: FIELD_NAMES[i],
  sortable: true,
  filter: "agTextColumnFilter",
  flex: 1,
  minWidth: 120,
  cellStyle: { display: "flex", alignItems: "center", justifyContent: "center" },
}));

export async function exportToExcel(generalTrade, modernTrade) {
  const wb = new ExcelJS.Workbook();
  const N  = HEADER_LABELS.length;

  const addSheet = (sheetName, tradeLabel, { sampleSize = 0, data = [] }) => {
    const ws = wb.addWorksheet(sheetName);

    // Title row
    const titleRow = ws.addRow([""]);
    ws.mergeCells(titleRow.number, 1, titleRow.number, N);
    const titleCell = ws.getCell(titleRow.number, 1);
    titleCell.value = {
      richText: [
        {
          text: "RED Project - Nepal - Daily Upload Status - ",
          font: { bold: true, color: { argb: "FFFFFFFF" }, size: 12, name: "Calibri" },
        },
        {
          text: tradeLabel,
          font: { bold: true, color: { argb: "FFFF0000" }, size: 12, name: "Calibri" },
        },
      ],
    };
    titleCell.fill      = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1F3864" } };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    titleRow.height     = 22;

    // Sample Size row
    const ssRow = ws.addRow(["Sample Size :", sampleSize]);
    ssRow.getCell(1).font      = { bold: true, size: 11 };
    ssRow.getCell(1).alignment = { horizontal: "right", vertical: "middle" };
    ssRow.getCell(2).fill      = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF00" } };
    ssRow.getCell(2).font      = { bold: true, size: 11 };
    ssRow.getCell(2).alignment = { horizontal: "center", vertical: "middle" };
    if (N > 2) ws.mergeCells(ssRow.number, 3, ssRow.number, N);
    ssRow.height = 18;

    // Header row
    const hRow = ws.addRow(HEADER_LABELS);
    hRow.height = 35;
    hRow.eachCell((cell) => {
      cell.fill      = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4472C4" } };
      cell.font      = { bold: true, color: { argb: "FFFFFFFF" }, size: 10, name: "Calibri" };
      cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      cell.border    = {
        top: { style: "thin" }, bottom: { style: "thin" },
        left: { style: "thin" }, right: { style: "thin" },
      };
    });

    // Data rows
    data.forEach((record) => {
      const values = FIELD_NAMES.map((f) => record[f] ?? "");
      const dRow   = ws.addRow(values);
      dRow.height  = 18;
      dRow.eachCell((cell) => {
        cell.font      = { size: 10 };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border    = {
          top: { style: "thin" }, bottom: { style: "thin" },
          left: { style: "thin" }, right: { style: "thin" },
        };
      });
    });

    COL_WIDTHS_EXCEL.forEach((w, i) => { ws.getColumn(i + 1).width = w; });
  };

  addSheet("General Trade", "GENERAL TRADE", generalTrade);
  addSheet("Modern Trade",  "MODERN TRADE",  modernTrade);

  const buf = await wb.xlsx.writeBuffer();
  saveAs(
    new Blob([buf], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    "DIS_Report.xlsx"
  );
}